// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WjYmE_upNXgOL3tI {
  background-color: #ffffff;
  margin-top: 20px;
  border-radius: 10px;
  padding: 20px;
  height: calc(100vh - 150px);
  position: relative;
}

.G5HlUxN0eUEB4eoc {
  padding: 20px;
  font-size: 24px;
  margin-bottom: 32px;
}

.KWXSSXddtiYJDtaQ {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.hNEoX8OPnK0guSTi {
  background-color: #0078ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Result/Result.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wrapper {\r\n  background-color: #ffffff;\r\n  margin-top: 20px;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  height: calc(100vh - 150px);\r\n  position: relative;\r\n}\r\n\r\n.result {\r\n  padding: 20px;\r\n  font-size: 24px;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.btnWrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 32px;\r\n}\r\n\r\n.paginationBtn {\r\n  background-color: #0078ff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `WjYmE_upNXgOL3tI`;
export var result = `G5HlUxN0eUEB4eoc`;
export var btnWrapper = `KWXSSXddtiYJDtaQ`;
export var paginationBtn = `hNEoX8OPnK0guSTi`;
export default ___CSS_LOADER_EXPORT___;
